<template>
  <div id="app">
    <div id="content">
      <Header
        :page="type"
        :title_one="'sanctions'"
        :action_one="''"
      ></Header>
      <PersonList
        @load="load()"
        :persons="persons"
        :type="'sanctions'"
        :team="team"
        @remove="remove"
        :estimate="+estimate"
        :estimate_minimum="+estimate_minimum"
        :key="this.$route.fullPath"
      ></PersonList>
    </div>
  </div>
</template>
<script>
import PersonList from '@/components/ui/PersonList'
import Header from '@/components/layout/Header'

export default {
  name: 'Sanctions',
  components: {
    PersonList,
    Header
  },
  data () {
    return {
      team: {},
      persons: [],
      type: '',
      estimate: '',
      estimate_minimum: ''
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },

    event () {
      return this.$store.getters['getCurrentEvent']()
    }
  },
  methods: {
    load () {
      var self = this
      // save type
      this.type = this.$route.name
      // admin load club info
      if (this.user.admin) {
        this.$store
          .dispatch('club/loadClubEvent', {
            club_id: this.user.club_id,
            event_id: this.user.event_id
          })
          .then(function () {})
      }
      // load information
      this.$store
        .dispatch('team/loadSanctionsTeam', { event_id: this.user.event_id, team_id: this.$route.params.team_id })
        .then(response => {
          var data = response.data
          Object.values(data).forEach(element => {
            if (parseInt(element.status) === 2) {
              element.status_sanction = 'competition.sanction.status.rejected'
            } else {
              if (!element.num_match) {
                element.status_sanction = 'competition.sanction.status.pending'
                element.status = 4
              } else if (+element.num_match === +element.matches_completed) {
                element.status_sanction = 'competition.sanction.status.completed'
              } else {
                element.status_sanction = 'competition.sanction.status.confirmed'
                element.status = 3
              }
            }
            let person = {
              name: element.person_name,
              surname: element.person_surname,
              match_name: element.match_name,
              comment: element.comment,
              type: element.type,
              num_match: element.num_match,
              matches_completed: element.matches_completed,
              status: element.status,
              status_sanction: element.status_sanction,
              round_name: element.round_name
            }
            self.persons.push(person)
          })
        })
    },
    remove (id) {
      for (var person in this.persons) {
        if (this.persons[person].id === id) {
          this.persons.splice(person, 1)
        }
      }
    }
  },
  watch: {
    // call again the method if the route changes
    $route: 'load'
  },
  created () {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
#app {
  background-color: #fff;
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
